import { getAuth, onAuthStateChanged } from "firebase/auth";
import { useContext, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth, useUser } from "reactfire";
import { AuthContext } from "../pages/auth/authContext";


interface PrivateRouteProps {
    children: JSX.Element;
  }
  const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);
    const [isVerified, setIsVerified] = useState<boolean>(false);

    useEffect(() => {
      const auth = getAuth();
      const unsubscribe = onAuthStateChanged(auth, (user) => {
        setIsAuthenticated(!!user);
        setIsVerified(user?.emailVerified || false);
      });
  
      return () => unsubscribe();
    }, []);
  
    if (isAuthenticated === null) {
      return <div>Loading...</div>; // Wait for Firebase initialization
    }

    if (!isVerified) {
      return <div>Check your email to verify</div>
    }
  
    return isAuthenticated ? children : <Navigate to="/login" />;
  };
export default PrivateRoute;